import { render, staticRenderFns } from "./insured_analysis.vue?vue&type=template&id=1446f13a&"
import script from "./insured_analysis.vue?vue&type=script&lang=js&"
export * from "./insured_analysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports